import config from '../../config/config'

const getImageServer = (url) => {
    return `${config.backendApi}/uploads/${url}`
}

export default getImageServer
